import { createFileRoute } from '@tanstack/react-router';

import { SharedBlockCreatePage } from '@/features/content';

export const Route = createFileRoute('/_authed/_active/org/shared-blocks/new/')({
  component: SharedBlockCreatePage,
});
